/* eslint-disable no-multi-str */
import { useDymoOpenLabel, useDymoCheckService } from "react-dymo-hooks";

let PrintLabels = ({ item_id, item_storage_date, item_found_location, original_item_container_name, item_description }) => {
  let printLabel = `<?xml version="1.0" encoding="utf-8"?>\
    <DieCutLabel Version="8.0" Units="twips">\
      <PaperOrientation>Landscape</PaperOrientation>\
      <Id>Address</Id>\
      <PaperName>30252 Address</PaperName>\
      <DrawCommands>\
        <RoundRectangle X="0" Y="0" Width="1581" Height="5040" Rx="270" Ry="270"/>\
      </DrawCommands>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_id}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>ID: </String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="331.2" Y="139.7656" Width="718.9062" Height="412.1094"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${original_item_container_name}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>CONT: </String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="331.2" Y="512.0632" Width="812.3086" Height="412.1094"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_storage_date}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>S-DATE: </String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="1940.942" Y="148.0512" Width="1042.783" Height="412.1094"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_id}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>${item_id}</String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="742.4749" Y="176.2345" Width="1048.956" Height="365.6591"/>\
      </ObjectInfo>\
      
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_description}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode></TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>${item_description}</String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="13" Bold="False" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="331.2" Y="912.6895" Width="4437.552" Height="524.2648"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>TEXT_1_2_1</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>F-LOC: </String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="2000.754" Y="529.0966" Width="887.084" Height="412.1094"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_storage_date}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>${item_storage_date}</String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="2918.941" Y="165.4358" Width="2032.136" Height="365.6591"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${original_item_container_name}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>${original_item_container_name}</String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="1021.681" Y="543.5274" Width="1527.986" Height="365.6591"/>\
      </ObjectInfo>\
      <ObjectInfo>\
        <TextObject>\
          <Name>${item_found_location}</Name>\
          <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
          <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>\
          <LinkedObjectName></LinkedObjectName>\
          <Rotation>Rotation0</Rotation>\
          <IsMirrored>False</IsMirrored>\
          <IsVariable>False</IsVariable>\
          <HorizontalAlignment>Left</HorizontalAlignment>\
          <VerticalAlignment>Middle</VerticalAlignment>\
          <TextFitMode>ShrinkToFit</TextFitMode>\
          <UseFullFontHeight>True</UseFullFontHeight>\
          <Verticalized>False</Verticalized>\
          <StyledText>\
            <Element>\
              <String>${item_found_location}</String>\
              <Attributes>\
                <Font Family="Lucida Grande" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>\
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>\
              </Attributes>\
            </Element>\
          </StyledText>\
        </TextObject>\
        <Bounds X="2918.941" Y="552.9664" Width="1635.851" Height="365.6591"/>\
      </ObjectInfo>\
    </DieCutLabel>`;
  const statusDymoService = useDymoCheckService();
  console.log(printLabel);
  const { label, statusOpenLabel, errorOpenLabel } = useDymoOpenLabel(statusDymoService, printLabel);
  if (label) {
    return <> <img src={"data:image/png;base64," + label} alt="dymo label preview" /> </>;
  } else {
    return <> </>;
  }

};



export default PrintLabels;